import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AccountTypeEnum, CareerProcessTypeEnum, CoiData, DiscoveryStatusEnum, PersonalUserData, UserMicroData, UserMinimalData, UserRole } from '../../moov-common/services/personal-user-data/personal-user-data';
import { GridStructureService } from 'src/app/moov-common/services/visual/grid-structure.service';
import { TileVisualData } from 'src/app/moov-common/services/visual/visual-data';
import { AbstractUserCoiService } from 'src/app/moov-common/services/user-coi/user-coi.abstract.service.';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { AbstractGuidedToursService } from 'src/app/moov-common/services/guided-tours/guided-tours.abstract.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { MatDialog } from '@angular/material/dialog';
import { TeamViewFiltersComponent } from '../team-view-filters/team-view-filters.component';
import { TranslateService } from '@ngx-translate/core';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import { LocalStorageService } from 'src/app/moov-common/services/localStorage';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import * as _ from 'lodash';
import { TeamMemberCardViewType } from 'src/app/moov-common/components/team-member-card/team-member-card.component';
import { ClaroEvents } from 'src/app/moov-common/services/google-analytics/analytics.enum';
import { QuickActionSelection } from 'src/app/moov-common/components/quick-actions/quick-actions/quick-actions.component';
import { ExternalRedirectOriginEnum, NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { IssuesCodes } from 'src/app/make-moov/model/issue-type.enum';
import { FilterDataOption, FilterOrgValueOptions } from 'src/app/moov-common/services/utils/utils-data';
import { MotivationPartialViewComponent } from 'src/app/moov-common/components/motivation-partial-view/motivation-partial-view/motivation-partial-view.component';


@Component({
  selector: 'app-team-view',
  templateUrl: './team-view.component.html',
  styleUrls: ['./team-view.component.scss']
})

export class TeamViewComponent extends BaseComponent implements OnInit {
  
  userId: string;
  userCircleOfInterest: CoiData;
  fullUserCircleOfInterest: CoiData;
  userDetails: PersonalUserData | undefined;
  commonRootFolder: string = '/assets/common/';
  selectedPOI: PersonalUserData;
  teamMemeberViewOpened: boolean = false;
  moovWizardOpened: boolean = false;
  @ViewChild("sidenav") sideNavRef: MatSidenav;
  openTeamMemberView = false;
  makeMoovWizardSkipIssue:boolean;
  makeMoovWizardSelectedIssue:string;
  makeMoovWizardSelectedMotivation: string;
  systemRecommendationsIssueId = "IS000";
  breakpoint: number;
  SINGLE_COL_BREAKPOINT_WIDTH = 400;
  MULTIPLE_COLS_NUM = 4;
  MOBILE_COLS_NUM = 2;
  selectedTeamMemberId = "";
  quickMoovAccessId = "";
  userDiscoveryStatus = DiscoveryStatusEnum;
  isOver = false;
  resellerMenuPresentSpinner = false;
  isTeamDataLoading = false;
  teamViewScopeEnumInstance = TeamMemberCardViewType;
  teamViewScope : TeamMemberCardViewType = TeamMemberCardViewType.MINIMAL;
  careerProcessTypeEnumInstance = CareerProcessTypeEnum;
  presentEmergancyCharge : boolean = false;
  presentDriverMoovsForTeam : boolean = false;
  presentChatOptionToTeamMemebers: boolean = false;
  showEnergyLevels: boolean = false;
  presentTeamPeers: boolean = true;
  teamFullMembersList: UserMinimalData[] = [];
  teamMembersList: UserMinimalData[] = [];
  managersList: UserMicroData[] = [];
  userRolesInstance = UserRole;
  isEmptyState : boolean = false;
  presentedTeamHeader: string = "";
  selectedTeamManagerId: string = "";
  presentTeamPeersButton: boolean = true;

  readonly VIEW_ROOT_MANAGER_ID = "ROOT";

  constructor(private readonly userCircleOfInterestDataService: AbstractUserCoiService, 
              public personalUserDataService: AbstractPersonalUserDataService, public dialog: MatDialog,
              private readonly gridStructureSerive: GridStructureService,
              private readonly guidedToursService: AbstractGuidedToursService,
              private readonly motivationsService: AbstractMotivationsService,
              private route: ActivatedRoute,
              private translate: TranslateService,
              private genderSerivce: GenderPipe,
              private localStorage : LocalStorageService,
              public router : Router
              ) {
    super();
    this.moovWizardOpened = false;
    }
  
  ngOnInit(): void {
    super.ngOnInit();

    if (this.user?.role == UserRole.EMPLOYEE){
      this.presentTeamPeers = true;
    }
    else{
      let presentTeamPeers = this.localStorage.getSecured<boolean>(LocalStorageKeys.presentTeamPeers);
      if (!presentTeamPeers){
        presentTeamPeers = false;
        this.localStorage.write<boolean>(LocalStorageKeys.presentTeamPeers, presentTeamPeers);
      }

      this.presentTeamPeers = presentTeamPeers;
    }

    this.verifyEmergancyRecharge();
    this.verifyTier();
    this.handleOrgIdOverride();
    this.initDriversOnlyLocalStorage();
    this.teamViewScope = this.getViewScope();
    this.analytics.sendClaroEvent(ClaroEvents.TeamViewLoadedWithScope, {'scope' : this.teamViewScope});
    this.sidebarTVChangeScope(this.teamViewScope);


    this.guidedToursService.trackUser(this.user!.id, true, this.user!.gender);

    if (this.isMobileView){
      this.breakpoint = this.MOBILE_COLS_NUM;
    }
    else{
     this.breakpoint = (window.innerWidth <= this.SINGLE_COL_BREAKPOINT_WIDTH) ? 1 : this.MULTIPLE_COLS_NUM;
    }
    
    this.buildTeamMembersAndGrid();
  }

  verifyTier(): void{

    if (this.user?.accountType === AccountTypeEnum.COLLAB || this.user?.accountType === AccountTypeEnum.EXCEL){
      this.presentChatOptionToTeamMemebers = true;

      // console.log(`TV - verifyTier presentChatOptionToTeamMemebers is ${this.presentChatOptionToTeamMemebers}`);
    }
  }

  handleOrgIdOverride(): void{
    let orgIdOverride: string = "";
    let storedResellerSelectedOrg : string = "";
    try{
      storedResellerSelectedOrg = this.localStorage.get<string>(LocalStorageKeys.resellerSelectedOrg)
      orgIdOverride = storedResellerSelectedOrg;
    }
    catch{
      // do nothing - if the value is not there orgId Override will stay empty string
    }

    if (orgIdOverride != "" && orgIdOverride != this.user?.orgId){
      this.presentTeamPeers = false;
      this.presentTeamPeersButton = false;
    }
    else{
      this.presentTeamPeersButton = true;
    }
  }

  onDriversOnlySlideChange(value: boolean): void{
    this.localStorage.write<boolean>(LocalStorageKeys.teamViewDriversOnly, value);
  }

  onPresentTeamPeersChange(): void{
    this.presentTeamPeers = !this.presentTeamPeers;
    this.localStorage.write<boolean>(LocalStorageKeys.presentTeamPeers, this.presentTeamPeers);
    this.buildTeamMembersAndGrid();
  }

  initDriversOnlyLocalStorage(): void{
    // first check if TV key is undefined
    if (this.localStorage.getSecured<boolean>(LocalStorageKeys.teamViewDriversOnly) == undefined){
      this.localStorage.write<boolean>(LocalStorageKeys.teamViewDriversOnly, false);
      return
    }

    if (!this.presentTeamPeers){
      this.showEnergyLevels = this.localStorage.getSecured<boolean>(LocalStorageKeys.teamViewDriversOnly) as boolean;
    }
    else{
      this.showEnergyLevels = false;
    }  
  }

  getViewScope():TeamMemberCardViewType{
    let viewScope = this.localStorage.getSecured<TeamMemberCardViewType>(LocalStorageKeys.teamViewScope);

    if (viewScope == undefined){
      viewScope = TeamMemberCardViewType.FULL;
    }
    
    return viewScope;
  }

  ngAfterViewInit(): void{
    this.route.queryParams.subscribe(params => {
      let counterpartId = params.counterpartId;
      let moovId = params.moovId;

      if (counterpartId == undefined && moovId == undefined){
      }
      else {
        this.analytics.teamMemberReviewedFromExternalLink(counterpartId);
        this.openPOI(counterpartId, moovId);
      }
    });

    this.analytics.teamViewPage();
  }

  verifyEmergancyRecharge() : void{
    this.personalUserDataService.verifyFeature(FeatureID.emergancyMoovsForTeam).subscribe(res => {
      this.presentEmergancyCharge = res;
    });

    this.personalUserDataService.verifyFeature(FeatureID.driverMoovsForTeam).subscribe(res => {
      this.presentDriverMoovsForTeam = res;
    });
  }

  onResize(event: any) {
    if (this.isMobileView){
      this.breakpoint = this.MOBILE_COLS_NUM;
    }
    else{
      // this.breakpoint = (event.target.innerWidth <= this.SINGLE_COL_BREAKPOINT_WIDTH) ? 1 : this.MULTIPLE_COLS_NUM;
      this.breakpoint = this.MULTIPLE_COLS_NUM;
    }
  }

  tileRowHeight():number {
  if (this.isMobileView){
    return (1/0.8)
  }
  else{
    return (1/0.625)
  }
}

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngAfterContentChecked(): void{
    // console.log(`TV ngAfterContentChecked`);
    // this.sideNavRef.open();
    // this.openTeamMemberView = False;
  }

  ngAfterContentInit(): void{
    // console.log(`TV ngAfterContentInit`);    
  }
  
  ngAfterViewChecked(): void{
    // console.log(`TV ngAfterViewChecked`);  
     //// TEMP //////
        // this.openPOI("UA06");
        //// END TEMP //////  
  }
  
  ngDoCheck(): void{
    // console.log(`TV ngDoCheck`);    
  }

  closeSideNav(): void{
    this.sideNavRef.close();
  }

  makeMoov() {
    this.sideNavRef.close();
    this.makeMoovWizardSkipIssue = false;
    this.makeMoovWizardSelectedIssue = "";
    this.makeMoovWizardSelectedMotivation = "";
    this.teamMemeberViewOpened = false;
    this.moovWizardOpened = true;
  }


  makeDirectMoov(counterpartId: string, selectedAction: QuickActionSelection) {
  console.log(`TV MDM`);
    // this.sideNavRef.close();
    this.makeMoovWizardSkipIssue = true;
    this.makeMoovWizardSelectedIssue = selectedAction.actionId;
    this.makeMoovWizardSelectedMotivation = selectedAction.motivationId;
    this.selectedTeamMemberId = counterpartId;
    this.teamMemeberViewOpened = false;
    this.moovWizardOpened = true;
  }

  closeMakeMoovWizard() {
    this.moovWizardOpened = false;
    this.teamMemeberViewOpened = true;

    this.openTeamMemberView = true;

    if (this.sideNavRef != undefined){
      this.sideNavRef.open();
    }
    else{
      console.log(`in TMV closeMakeMoovWizard, sideNavRef is undefined`);
    }
  }

  createImageFromBlob(image: any, userDetails: PersonalUserData) {
    const base64_response = this.utilsService.arrayBufferToBase64(image);
    userDetails.image = 'data:image/png;base64,'+base64_response;
  }

  getTileWidth(tileIndex:number){
    const tileDetails: TileVisualData = this.gridStructureSerive.getGridTileSize(this.teamMembersList.length, tileIndex)
    return tileDetails.width;
  }

  getTileHeight(tileIndex:number){``
    const tileDetails: TileVisualData = this.gridStructureSerive.getGridTileSize(this.teamMembersList.length, tileIndex)
    return tileDetails.height;
  }

  buildTeamMembersAndGrid(): void{
      this.isTeamDataLoading = true;
      this.isEmptyState = false;

      let orgIdOverride: string = "";
      let storedResellerSelectedOrg : string = "";
      try{
        storedResellerSelectedOrg = this.localStorage.get<string>(LocalStorageKeys.resellerSelectedOrg)
        orgIdOverride = storedResellerSelectedOrg;

        if (orgIdOverride == FilterOrgValueOptions.EMPTY){
          orgIdOverride = "";
        }
      }
      catch{
        // do nothing - if the value is not there orgId Override will stay empty string
      }

      if (orgIdOverride != ""){
        this.presentTeamPeers = false;
      }


      if (!this.presentTeamPeers){
        let managerIdOverride = this.localStorage.getSecured<string>(LocalStorageKeys.teamViewFilterBYManager);

        if (!managerIdOverride){
          managerIdOverride = "";
        }

        let isRequestingRootData = false;
        if (managerIdOverride == this.VIEW_ROOT_MANAGER_ID){
          managerIdOverride = "";
          isRequestingRootData = true;
        }

        // present the user's subordinates
        this.userCircleOfInterestDataService.getUserCOI(orgIdOverride, managerIdOverride, isRequestingRootData).subscribe(coiDetails => {

          // console.log(`in TV buildTeamMembersAndGrid coiDetails are ${JSON.stringify(coiDetails)}`);

          this.teamFullMembersList = coiDetails.teamMembersList.concat(coiDetails.peopleOfInterest);

          this.initDriversOnlyLocalStorage();

          const filterByMgr_mgrId = this.localStorage.getSecured<string>(LocalStorageKeys.teamViewFilterBYManager);
          if (filterByMgr_mgrId){
            this.selectedTeamManagerId = filterByMgr_mgrId;
          }
          else{
            this.selectedTeamManagerId = "";
          }
          
          this.teamMembersList = this.teamFullMembersList;
            this.resellerMenuPresentSpinner = false;
            this.isTeamDataLoading = false;

            if (this.teamMembersList.length > 0){
              this.isEmptyState = false;
            }
            else{
              this.isEmptyState = true;
            }

            if (this.selectedTeamManagerId != ""){
              this.teamMembersList = this.utilsService.moveToStartOfList(this.teamMembersList, this.selectedTeamManagerId);
            }

            this.verifyViewHeader();
          });  
      }
      else{
        
        // present the user peers and not his subordinates
        this.userCircleOfInterestDataService.usersOfInterestToTeam().subscribe(usersOfInterest => {
          this.initDriversOnlyLocalStorage();
          this.teamFullMembersList = usersOfInterest;
          this.teamMembersList = this.teamFullMembersList;
          this.resellerMenuPresentSpinner = false;
          this.isTeamDataLoading = false;

          if (this.teamMembersList.length > 0){
            this.isEmptyState = false;
          }
          else{
            this.isEmptyState = true;
          }

          if (this.user?.parentId != ""){
            this.teamMembersList = this.utilsService.moveToStartOfList(this.teamMembersList, this.user!.parentId);
          }

          this.verifyViewHeader();
        });
      }

      // regardless get the managers list
      this.userCircleOfInterestDataService.getManagersBelow(orgIdOverride).subscribe(managersList => {

        this.managersList = managersList;
      });
  }

  verifyViewHeader(): void{
    let managerIdOverride = this.localStorage.getSecured<string>(LocalStorageKeys.teamViewFilterBYManager);

    if (this.presentTeamPeers){
      // presenging peers
      this.presentedTeamHeader = this.translate.instant('teamView.teamViewPresentedTeamHeader_Peers');
    }
    else if (!managerIdOverride || managerIdOverride == "" || managerIdOverride == this.user!.id){
      // presenting own team
      this.presentedTeamHeader = this.translate.instant('teamView.teamViewPresentedTeamHeader_Own');
    }
    else if (managerIdOverride == this.VIEW_ROOT_MANAGER_ID){
      // presenting root
      this.presentedTeamHeader = this.translate.instant('teamView.teamViewPresentedTeamHeader_Root');
    }
    else{
      const teamLeaderDetails = this.teamFullMembersList.find(teamMember => teamMember.id == managerIdOverride);

      if (teamLeaderDetails){
        // presenting other team
        let teamLeaderName = teamLeaderDetails.firstName + " " + teamLeaderDetails.lastName;

        this.presentedTeamHeader = this.translate.instant('teamView.teamViewPresentedTeamHeader', {teamLeaderName: teamLeaderName});
      }
      else{
        this.presentedTeamHeader = this.translate.instant('teamView.teamViewPresentedTeamHeader_Root');
      }
    }
  }

  openPOI(counterpartId:string, moovId: string = ""): void{

    this.router.navigate([NAVIGATION_ROUTES.app.detailsView + "/" + counterpartId]);
  }

  chatAboutTeamMember(counterpartId: string) : void{
    const counterpartDetails : UserMinimalData | undefined = this.teamFullMembersList.find(teamMember => teamMember.id == counterpartId);

    if (!counterpartDetails){
      return;
    }

    let questionText = this.translate.instant('chatView.teamMemberChatPrefix');

    questionText = questionText + ' ' + counterpartDetails.firstName + ' ' + counterpartDetails.lastName

    let queryParamsList: { [key: string]: any } = {}; 

    queryParamsList["questionText"] = questionText;
    queryParamsList["origin"] = ExternalRedirectOriginEnum.USER_TEAM_VIEW;

    this.router.navigate([NAVIGATION_ROUTES.app.chatView], {queryParams: queryParamsList});

  }

  rechargeForTeamMember(counterpartId : string) : void{
    const selectedAction : QuickActionSelection = {actionId:IssuesCodes.teamMemberRecharge, motivationId: ''};
    this.makeDirectMoov(counterpartId, selectedAction);
  }

  increaseEngagementForTeamMember (counterpartId: string): void {
    const selectedAction : QuickActionSelection = {actionId:IssuesCodes.increaseTeamMemberEngagement, motivationId: ''};
    this.makeDirectMoov(counterpartId, selectedAction);
  }

  getPOIData (id:string): UserMinimalData | undefined{
    let currPOIData:UserMinimalData|undefined = this.teamMembersList.find(x => x.id ==id);

    if (currPOIData == undefined){
      currPOIData = this.userCircleOfInterest.peopleOfInterest.find(x => x.id == id)
    }

    return currPOIData;
  }

  openMotivationDetails(motivationId:string): void{
    this.dialog.open(MotivationPartialViewComponent, {
      height: '500px',
      width: '600px',
      data: {selectedMotivationId:motivationId, isRTL:this.isRTL, isSelf:false}
    });
  }

  activeMoovChanged(): void{
    this.buildTeamMembersAndGrid();
  }
 
  isMoovViewOpened(): boolean {
    return true;
  }

  resellerChangeOrg(){
    this.resellerMenuPresentSpinner = true;
    this.personalUserDataService.getAllUserCreatedOrgs().subscribe(orgsList => {

      let orgList : FilterDataOption[] = [];
      for (let currOrgData of orgsList){
          orgList.push({"name":currOrgData.name,"value": currOrgData.id});
      }

      orgList.sort((a, b) => a.name.localeCompare(b.name));
      orgList.unshift({name: this.translate.instant('stateView.selectOrg_PresentForMe'), value: FilterOrgValueOptions.EMPTY});

      this.resellerMenuPresentSpinner = false;

      let dialogRef = this.dialog.open(TeamViewFiltersComponent, {
        height: 'fit-content',
        width: 'fit-content',
        panelClass: 'claro-custom-dialog',
        data: {} 
      });

      let componentInstance = dialogRef.componentInstance;
      componentInstance.filterDataList = orgList;
      componentInstance.filterHeader = this.translate.instant(this.genderSerivce.transform("teamView.orgListFilterHeader"));

      dialogRef.afterClosed().subscribe(selectedValue => {
        if (selectedValue && selectedValue != ""){
          this.changeOrg(selectedValue);
        }
      });
    });
  }

  resellerFilterByParent(): void{
    let mgrsList : FilterDataOption[] = [];
    this.resellerMenuPresentSpinner = true;


    // mgrsList.push({"name":this.translate.instant('teamViewFilter.showAll'),"value": ""});
    mgrsList.push({"name":this.translate.instant('teamViewFilter.showDirectSubordinates'),"value": this.user!.id});
    if (this.user?.role == UserRole.HR){
      mgrsList.push({"name":this.translate.instant('teamViewFilter.showRoot'),"value": this.VIEW_ROOT_MANAGER_ID});
    }

    for (let currManager of this.managersList){
        mgrsList.push({"name":currManager.firstName+" "+currManager.lastName,"value": currManager.id});
      }

    // Sort managers list by name, keeping the first two entries at the top
    const firstTwoEntries = mgrsList.splice(0, this.user?.role == UserRole.HR ? 2 : 1);
    mgrsList.sort((a, b) => a.name.localeCompare(b.name));
    mgrsList.unshift(...firstTwoEntries);

    this.resellerMenuPresentSpinner = false;

      let dialogRef = this.dialog.open(TeamViewFiltersComponent, {
        height: 'fit-content',
        width: 'fit-content',
        panelClass: 'claro-custom-dialog',
        data: {} 
      });

      let componentInstance = dialogRef.componentInstance;
      componentInstance.filterDataList = mgrsList;
      componentInstance.filterHeader = this.translate.instant(this.genderSerivce.transform("teamView.managerFilterHeader"));

      dialogRef.afterClosed().subscribe(selectedValue => {
        this.filterByManager(selectedValue);
      });
  }

  filterByManager(managerId: string){
    if (managerId == undefined){
      // managerId is undefiened - no manager was selected
      return;
    }

    this.resellerMenuPresentSpinner = true;
    this.selectedTeamManagerId = managerId;
    this.localStorage.write(LocalStorageKeys.teamViewFilterBYManager, managerId);
    this.buildTeamMembersAndGrid();
  }

  changeOrg(orgId: string){
    this.resellerMenuPresentSpinner = true;
    this.localStorage.write(LocalStorageKeys.resellerSelectedOrg, orgId);
    // Zero filter for manager
    this.localStorage.write(LocalStorageKeys.teamViewFilterBYManager, "");
    this.selectedTeamManagerId = "";
    this.handleOrgIdOverride();
    this.buildTeamMembersAndGrid();
  }

  sidebarTVChangeScope(scope: TeamMemberCardViewType): void{
    this.teamViewScope = scope;

    this.analytics.sendClaroEvent(ClaroEvents.TeamViewScopeChange, {'scope':this.teamViewScope});
    this.localStorage.write<TeamMemberCardViewType>(LocalStorageKeys.teamViewScope, this.teamViewScope);
  }
}
